import { Component, inject, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Drawer } from 'primeng/drawer';
import { RoutedOutletService } from '@irian-ro/navigation-module';

@Component({
  selector: 'shell-api-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [Drawer, RouterOutlet],
})
export class SidebarComponent implements OnDestroy {
  sidebarVisible = true;
  router = inject(Router);
  private routedOutletService = inject(RoutedOutletService);

  back() {
    this.router.navigate([
      '/',
      {
        outlets: {
          sidebar: null,
        },
      }
    ]);
  }

  ngOnDestroy(): void {
    this.routedOutletService.resolve('sidebar');
  }
}
